import { Controller } from "@hotwired/stimulus";

// Bottom mobile nav: on tap, immediately grows the tapped item into an
// amber pill with its label and squeezes the rest back to icon-only —
// before Turbo finishes navigating — so the animation is visible instead
// of just snapping straight to the new page's already-active state.
export default class extends Controller {
  static targets = ["item", "label"];

  select(event) {
    const target = event.currentTarget;
    this.itemTargets.forEach((item) => this.setActive(item, item === target));
  }

  setActive(item, active) {
    item.classList.toggle("flex-[4]", active);
    item.classList.toggle("bg-amber-500", active);
    item.classList.toggle("text-neutral-950", active);
    item.classList.toggle("shadow-[0_2px_10px_rgba(245,158,11,0.45)]", active);
    item.classList.toggle("flex-1", !active);
    item.classList.toggle("text-neutral-400", !active);

    const label = item.querySelector("[data-bottom-nav-target='label']");
    if (!label) return;
    label.classList.toggle("max-w-[120px]", active);
    label.classList.toggle("opacity-100", active);
    label.classList.toggle("max-w-0", !active);
    label.classList.toggle("opacity-0", !active);
  }
}
